{
  "id": 19,
  "location": "paris",
  "difficulty": "normal",
  "moves": 24,
  "kinds": 6,
  "goals": [
    { "type": "collect", "kind": "croissant", "count": 36 },
    { "type": "collect", "kind": "cookie", "count": 36 }
  ],
  "stars": [4660, 5720],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.784, "movesLeft": 5.1, "closeLosses": 0.089, "target": 0.77 }
}
